import { useMemo } from 'react'
import { useSWRConfig } from 'swr'
import { composeSwrKey, serializeSwrKey } from '../stale-while-revalidate/cache-key'
import { useApiRestClient } from '../providers/api-rest-client/api-rest-client'

export const useApiCache = ({ method, key, args = {} }) => {
	const { cache: cache } = useSWRConfig()
	const client = useApiRestClient()

	const swrKey = composeSwrKey({ client, method, key, args })
	const swrKeySerialized = serializeSwrKey(swrKey)

	return useMemo(
		() => ({
			get: () => cache.get(swrKeySerialized),
			set: (value) => cache.set(swrKeySerialized, value),
			merge: (value) => cache.set(swrKeySerialized, { ...cache.get(swrKeySerialized), ...value }),
			delete: () => cache.delete(swrKeySerialized),
			deleteData: () => cache.set(swrKeySerialized, { ...cache.get(swrKeySerialized), data: undefined }),
		}),
		[cache, swrKeySerialized]
	)
}
